import React, { memo } from 'react'
import { interestMarketingConfig } from '../config'
import Sections from '../components/sections'

const InterestMarketingModal = memo(() => (
  <div>
    <Sections sections={interestMarketingConfig} />
  </div>
))
InterestMarketingModal.displayName = 'InterestMarketingModal'
export default InterestMarketingModal
